import CaseSummary from './CaseSummary.vue';

export default CaseSummary;
